<template>
  <div class="contactus">
    <v-head></v-head>
    <div class="contactus_main">
      {{{contactus_list}}}
    </div>

    <!--<div class="contactus_banner">
      <img src="../../../static/images/contactus.jpg" alt="">
    </div>
    <div class="contactus_content">
      <div class="contactus_p">
        <p>深圳市娜尔思时装有限公司</p>
        <p>SHENZHEN NAERSI FASHION CO.,LTD.</p>
        <p>地址：广东省深圳市福田区泰然六路50号红松大厦B座 5楼</p>
        <p>ADD:5F，B BLOCK, HongSong Building,No.50 Terra 6th Rd,Futian Dist,Shenzhen,China</p>
        <p>Tex:0755-8836855</p>
        <p>Fax:0755-88368499</p>
      </div>
      <div class="contactus_league">
        <div class="contactus_league_title">
          品牌加盟
        </div>
        <div class="contactus_league_content">
          <p>1.有独立承担民事责任能力的自然人或独立承担民事责任的企业法人。</p>
          <p>2.对赢家服饰品牌有一定了解，理解并认同品牌理念，有共同发展的信心。</p>
          <p>3.具备150万元以上流动资金，首批汇款不低于60万元。</p>
          <p>4.新加盟客户需交纳考察费用5000元，合同保证金2万元。（考察通过后由公司承担考察费用，如果没有通过，则扣除意向金）</p>
          <p>5.有足够经营使用面积（专柜或专卖店100平米以上）。</p>
          <p>6.相应商场或专卖一条街有知名盛年女装品牌4个以上。</p>
          <p>7.女装品牌经营至少2年以上经验，具备店铺经营管理能力。PS：以上款项标注均为人民币。</p>
          <p><strong>加盟热线：0755-88368290（张小姐）</strong></p>
        </div>

      </div>
    </div>-->
    <v-footer></v-footer>
  </div>
</template>

<script>
  import head from 'components/head/head.vue';
  import footer from 'components/footer/footer.vue';
  export default {
    data () {
      return {
        contactus_list:""
      }
    },
    components: {
      "v-head": head,
      "v-footer": footer
    },
    ready () {
      var _this = this;
      $.ajax({
        type: "get",
        url: __formalUrl__ + "api/getNewsById/275",
        data: {},
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(111222, data)
            _this.contactus_list = data.content;
          }
        },
      })
    }
  }
</script>

<style>
  *{font-size: 0.16rem}
  .contactus{width: 9rem;margin: 0 auto;font-size: 0.16rem}
  .contactus_main{margin-top: 0.5rem}
  .contactus_banner{width: 9rem;height: 3rem;margin-top: 0.5rem}
  .contactus_banner img{width: 100%;height: 100%}
  .contactus_content{width: 100%}
  .contactus_p{width: 100%;text-align: center;font-size: 0.15rem;line-height: 0.3rem}
  .contactus_p p:nth-child(1){font-size: 0.25rem;margin-top: 0.3rem}
  .contactus_p p:nth-child(2){font-size: 0.25rem;margin-bottom: 0.3rem}
  .contactus_league{width: 8.5rem;height:4rem;border: 0.01rem solid #222846;margin: 0 auto}
  .contactus_league_title{width: 8.5rem;background-color: #222846;text-align: center;color: #ffffff;font-size: 0.25rem;line-height: 0.56rem;margin: 0 auto}
  .contactus_league_content{font-size: 0.16rem;line-height: 0.3rem;padding-top: 0.3rem}
  @media screen and (max-width: 30em) and (min-width:20em ){
    section{width: 100% !important}
    article{width: 100% !important}
    p{width: 100% !important}
    .contactus{width: 100%;margin: 0 auto;}
    .contactus_banner{width: 100%;height: auto;margin-top: 0.5rem}
    .contactus_banner img{width: 100%;height: 100%}
    .contactus_content{width: 100%}
    .contactus_p{width: 100%;text-align: center;font-size: 0.15rem;line-height: 0.3rem}
    .contactus_p p:nth-child(1){font-size: 0.25rem;margin-top: 0.3rem}
    .contactus_p p:nth-child(2){font-size: 0.25rem;margin-bottom: 0.3rem}
    .contactus_league{width: 100%;height:4rem;border: 0.01rem solid #222846;margin: 0 auto;box-sizing: border-box}
    .contactus_league_title{width: 100%;background-color: #222846;text-align: center;color: #ffffff;font-size: 0.20rem;line-height: 0.56rem;margin: 0 auto}
    .contactus_league_content{font-size: 0.12rem;line-height: 0.3rem;padding-top: 0.3rem}
  }

</style>



// WEBPACK FOOTER //
// contactus.vue?3bf30786